export default "/_next/static/images/uploadImageIcon-b6600e26d2d029276ea62a0553edc275.png";